"use strict";

exports.__esModule = true;
exports.isAboveDays = isAboveDays;
exports.isAboveMonths = isAboveMonths;
exports.isBelowDays = isBelowDays;
exports.isBelowMonths = isBelowMonths;
function isAboveDays(timestampStr, days, isInclusive) {
  const timestamp = Number.parseInt(timestampStr, 10);
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + days);
  return isInclusive ? new Date(timestamp) >= currentDate : new Date(timestamp) > currentDate;
}
function isBelowDays(timestampStr, days, isInclusive) {
  const timestamp = Number.parseInt(timestampStr, 10);
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + days);
  return isInclusive ? new Date(timestamp) <= currentDate : new Date(timestamp) < currentDate;
}
function adjustMonth(months) {
  const currentDate = new Date();
  if (months !== 0) {
    currentDate.setDate(1);
    currentDate.setHours(0);
    currentDate.setMinutes(0);
    currentDate.setSeconds(0);
    currentDate.setMilliseconds(0);
    currentDate.setMonth(currentDate.getMonth() + months);
  }
  return currentDate;
}
function isBelowMonths(timestampStr, months, isInclusive) {
  const timestamp = Number.parseInt(timestampStr, 10);
  const currentDate = adjustMonth(months);
  return isInclusive ? new Date(timestamp) <= currentDate : new Date(timestamp) < currentDate;
}
function isAboveMonths(timestampStr, months, isInclusive) {
  const timestamp = Number.parseInt(timestampStr, 10);
  const currentDate = adjustMonth(months);
  return isInclusive ? new Date(timestamp) >= currentDate : new Date(timestamp) > currentDate;
}